const RELOAD_KEY = 'humeo_chunk_reload';
const MAX_RELOADS = 3;

const STALE_CHUNK_PATTERNS = [
  'Loading chunk',
  'Loading CSS chunk',
  'is not a valid JavaScript MIME type',
  'Failed to fetch dynamically imported module',
  'error loading dynamically imported module',
  'Importing a module script failed',
];

export function isStaleChunkError(errorOrMessage: Error | string): boolean {
  const name = errorOrMessage instanceof Error ? errorOrMessage.name : '';
  const message =
    errorOrMessage instanceof Error
      ? errorOrMessage.message || ''
      : errorOrMessage;

  return (
    name === 'ChunkLoadError' ||
    STALE_CHUNK_PATTERNS.some((pattern) => message.includes(pattern))
  );
}

/**
 * Attempts a guarded page reload to recover from stale chunks.
 * Returns `true` if the page will reload, `false` if max retries exhausted.
 */
export function attemptStaleChunkReload(): boolean {
  try {
    const reloadCount = Number(sessionStorage.getItem(RELOAD_KEY) || '0');

    if (reloadCount >= MAX_RELOADS) {
      sessionStorage.removeItem(RELOAD_KEY);
      return false;
    }

    sessionStorage.setItem(RELOAD_KEY, String(reloadCount + 1));
    window.location.reload();
    return true;
  } catch {
    // sessionStorage unavailable (e.g. restricted WebView) — skip reload guard
    return false;
  }
}

export function clearStaleChunkReloadCounter(): void {
  try {
    sessionStorage.removeItem(RELOAD_KEY);
  } catch {
    // sessionStorage unavailable — nothing to clear
  }
}
